import { IElementTypeEditInfo } from './../models/index'

export const readerEditInfo = {
    editExcludeFields: []
}